import * as Joi from 'joi';
import { commonV1DeprecatedProps } from './v1';
import { AxisPropertiesSchema, ChartPropertiesSchemaV2, ClientStateV2Class, } from './v2';
class ClientStateV3Class extends ClientStateV2Class {
}
const ColumnPropertiesSchemaV3 = Joi.object({
    __typename: Joi.string(),
    dataLabels: Joi.boolean().allow(null),
    format: Joi.any(),
});
const ClientStateV3Schema = Joi.object({
    axisProperties: Joi.object().pattern(Joi.string(), AxisPropertiesSchema),
    columnProperties: Joi.object().pattern(Joi.string(), ColumnPropertiesSchemaV3),
    chartProperties: ChartPropertiesSchemaV2,
    custom_color_selector_array: Joi.array().items(Joi.string()),
    systemSeriesColors: Joi.object().pattern(Joi.string().allow(''), Joi.string()),
    seriesColors: Joi.object().pattern(Joi.string().allow(''), Joi.string()),
    systemMultiColorSeriesColors: Joi.object().pattern(Joi.string(), Joi.object().pattern(Joi.string().allow(''), Joi.array().items(Joi.string().allow(null)))),
    multiColorSeriesColors: Joi.object().pattern(Joi.string(), Joi.object().pattern(Joi.string().allow(''), Joi.array().items(Joi.string().allow(null)))),
    version: Joi.string().valid('V3'),
    ...commonV1DeprecatedProps,
});
export { ClientStateV3Schema, ClientStateV3Class, ColumnPropertiesSchemaV3 };
//# sourceMappingURL=v3.js.map